import { Button, Stack, TextField } from "@mui/material";
import { useState } from "react";

interface Props {
  title: string | undefined;
  loading: boolean;
  validationError: string | undefined;
  placeholder: string;
  onApply: (newTitle: string) => void | Promise<void>;
  onClose: () => void;
  onTitleChanged?: (newTitle: string) => void;
}

const InlineTitleEditor = ({
  title,
  onApply,
  validationError,
  onClose,
  loading,
  onTitleChanged,
  placeholder,
}: Props) => {
  const [newTitle, setNewTitle] = useState(title || "");

  const handleApply = () => {
    onApply(newTitle.trim());
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleApply();
      return;
    }
    if (e.key === "Escape") {
      e.preventDefault();
      onClose();
      return;
    }
  };

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexGrow: 1, position: "relative" }}>
      <TextField
        autoFocus
        placeholder={placeholder}
        focused
        sx={{
          "& .MuiOutlinedInput-root": { maxHeight: "30px" },
          "& .MuiFormHelperText-root": { mt: 0.125, position: "absolute", left: 0, top: "100%" },
          minWidth: "7.5rem",
          width: "100%",
        }}
        value={newTitle}
        onChange={(e) => {
          setNewTitle(e.target.value);
          onTitleChanged?.(e.target.value);
        }}
        onKeyDown={handleKeyDown}
        error={!!validationError}
        helperText={validationError}
      />
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", py: 0.5 }}>
        <Button variant="outlined" color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" loading={loading} onClick={handleApply} disabled={!!validationError}>
          Apply
        </Button>
      </Stack>
    </Stack>
  );
};

export default InlineTitleEditor;
